// extracted by mini-css-extract-plugin
module.exports = {"left":"NotesAndTasksStyles_left__Wt5f_","right":"NotesAndTasksStyles_right__3oB3s","button":"NotesAndTasksStyles_button__1OAXf"};